<template>
  <div class="app-haeder">
    <div class="app-sidemenu-toggle">
      <i class="fa fa-bars"></i>
    </div>
    <a class="app-header-app-name" href="/">
      <img src="/android-chrome-192x192.png" style="width: 22px" />
      Pamarin Developers
    </a>
    <a v-if="showSwaggerButton" href="https://api.pamarin.com/swagger" target="_blank" class="app-button-swagger btn btn-sm">Swagger</a>
    <div class="app-login-information" style="display: none">
      <span class="app-login-user-name"> Developer </span>
      <div class="app-login-user-image" @click="login()"></div>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    showSwaggerButton : null
  }
};
</script>